import { FC, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { ProcessingStep } from './ProcessingStep';
import { TProcessingStepsLoaderProps } from './types';

const DEFAULT_STEP_DURATION_MS = 2500;

export const ProcessingStepsLoader: FC<TProcessingStepsLoaderProps> = ({
	steps,
	stepDurationMs = DEFAULT_STEP_DURATION_MS,
	loopStartIndex,
}) => {
	const [activeStep, setActiveStep] = useState(0);
	const loopStart = Math.max(loopStartIndex ?? steps.length - 2, 0);

	useEffect(() => {
		const interval = setInterval(() => {
			setActiveStep((prev) => (prev >= steps.length - 1 ? loopStart : prev + 1));
		}, stepDurationMs);
		return () => clearInterval(interval);
	}, [steps.length, stepDurationMs, loopStart]);

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, py: 1 }}>
			{steps.map((step, index) => (
				<ProcessingStep
					key={step.label}
					label={step.label}
					icon={step.icon}
					isActive={index === activeStep}
					isDone={index < activeStep}
				/>
			))}
		</Box>
	);
};
